<template>
    <div class="animated fadeIn">
        <NewTicketModal @ticketCreated="onTicketCreated" />

        <b-row>
            <b-col sm="4">
                <h1>
                    {{ $t('label.tickets') }}
                    <div class="pull-right">
                        <b-button variant="success" v-b-modal.NewTicket>
                            {{ $t('label.createTicket') }}
                            <i class="fa fa-ticket"></i>
                        </b-button>
                    </div>
                </h1>

                <b-card no-body>
                    <b-card-header v-if="true">
                        <b-input-group>
                            <!-- Show scope dropdown -->
                            <b-dropdown
                                :text="selectedscope.text"
                                variant="secondary"
                                slot="append"
                            >
                                <b-dropdown-item
                                    v-for="scope in availableScopes"
                                    :key="scope.name"
                                    @click="setScope(scope)"
                                    >... {{ scope.text }}</b-dropdown-item
                                >
                            </b-dropdown>
                            <!-- Textfilter -->
                            <b-form-input
                                placeholder="Filter"
                                v-model="ticketFilter"
                            ></b-form-input>
                        </b-input-group>
                        <b-form-checkbox-group
                            id="checkboxRow"
                            name="statuses"
                            v-model="selectedStatuses"
                        >
                            <b-form-checkbox
                                v-for="status in statuses"
                                :key="status.id"
                                :value="status.id"
                                >{{ status.name }}</b-form-checkbox
                            >
                        </b-form-checkbox-group>
                    </b-card-header>
                    <b-list-group flush v-if="loading">
                        <b-list-group-item>
                            <spinner />
                        </b-list-group-item>
                    </b-list-group>
                    <b-list-group flush v-if="!loading">
                        <b-list-group-item
                            :key="ticket.id"
                            v-for="ticket in computedTickets.slice(
                                pagination.perPage *
                                    (pagination.currentPage - 1),
                                pagination.perPage * pagination.currentPage
                            )"
                            @click="setTicket(ticket)"
                            :active="ticket == selectedTicket"
                            button
                        >
                            <b-badge variant="primary" pill
                                >#{{ ticket.human_id }}</b-badge
                            >
                            <b-badge
                                variant="light"
                                pill
                                class="pull-right"
                                style="font-weight: normal;"
                            >
                                {{ getMomentFromNow(ticket.modified) }}
                            </b-badge>
                            {{ ticket.subject }}
                            <div
                                v-if="false"
                                v-html="ticket.description"
                                style="max-height: 3em; overflow: hidden"
                            ></div>
                        </b-list-group-item>
                    </b-list-group>
                    <b-list-group-item v-if="!loading && tickets.length > 0">
                        <nav style="margin: 0 0">
                            <b-pagination
                                size="md"
                                :total-rows="computedTickets.length"
                                :per-page="pagination.perPage"
                                v-model="pagination.currentPage"
                                :prev-text="$t('label.next')"
                                :next-text="$t('label.previous')"
                            />
                        </nav>
                    </b-list-group-item>
                    <b-list-group-item v-if="tickets.length == 0 && !loading">{{
                        $t('label.nothingHere')
                    }}</b-list-group-item>
                </b-card>
            </b-col>
            <b-col sm="8">
                <Ticket v-if="selectedTicket" :ticket="selectedTicket" />
            </b-col>
        </b-row>
    </div>
</template>

<script>
import Ticket from './_ticketId'
import NewTicketModal from '@/components/Tickets/NewTicketModal'
import moment from 'moment'

import api from '@/http/http-common'

const $http = api

export default {
    name: 'Tickets',
    props: {},
    components: {
        Ticket,
        NewTicketModal,
    },
    data() {
        return {
            loading: true,
            tickets: [],
            statuses: [],
            selectedTicket: false,
            selectedscope: {},
            ticketModalVisible: false,
            selectedStatuses: [],
            ticketFilter: '',
            ticketScopes: [
                {
                    name: 'personal',
                    text: this.$t('label.myTickets'),
                    rank: 60,
                },
                {
                    name: 'department',
                    text: this.$t('label.myUnit'),
                    rank: 50,
                },
                {
                    name: 'company',
                    text: this.$t('label.allUnits'),
                    rank: 30,
                },
            ],
            pagination: {
                perPage: 15,
                currentPage: 1,
            },
        }
    },

    created() {
        // console.log('Ticket created', this.tickets)
        this.selectedscope = this.ticketScopes[0]
        this.getTickets()
    },

    methods: {
        onTicketCreated(ticket) {
            // console.log('onTicketCreated', ticket)
            this.selectedTicket = this.transformTicket(ticket)
            this.ticketModalVisible = false
            this.getTickets()
        },

        getTickets() {
            this.loading = true
            let scope = this.selectedscope.name
            return $http
                .get('/services/tickets?scope=' + scope)
                .then(res => res.data)
                .then(data => {
                    this.tickets = data.tickets
                    this.onTicketResponse(data)
                    return this.tickets
                })
        },

        onTicketScopeChange(scope) {
            this.selectedscope = scope
            this.getTickets()
        },

        getMomentFromNow(ts) {
            try {
                return ts.fromNow()
            } catch (err) {
                console.warn(ts, err)
                return ''
            }
        },

        onTicketResponse(data) {
            if (data === null || data.tickets.length === 0) {
                this.loading = false
                return
            }
            this.tickets = data.tickets.map(ticket => {
                return {
                    id: ticket.id,
                    human_id: ticket.requestNumber,
                    subject: ticket.subject,
                    description: ticket.description,
                    modified: moment(ticket.modified),
                    created: moment(ticket.created),
                    solution: ticket.solution,
                    priority: (priority => {
                        if (!priority) return null
                        return {
                            name: priority.name,
                            id: priority.id,
                            color: priority.color,
                        }
                    })(
                        data.linked.priorities.find(
                            priority => priority.id == ticket.priorityId
                        )
                    ),
                    status: (status => {
                        if (!status) return {}
                        return {
                            id: status.id,
                            name: status.userDisplayName,
                        }
                    })(
                        data.linked.statuses.find(
                            status => status.id == ticket.statusId
                        )
                    ),
                    user: (user => {
                        if (!user) return {}
                        return {
                            firstName: user.firstName,
                            name: user.fullName,
                            department: (department => {
                                if (!department) return {}
                                return department.name
                            })(
                                data.linked.companydepartments.find(
                                    dep => dep.id == user.companyDepartmentId
                                )
                            ),
                        }
                    })(
                        data.linked.users.find(user => user.id == ticket.userId)
                    ),
                }
            })
            let statuses = data.linked.statuses
                .map(status => {
                    return {
                        id: status.id,
                        name: status.name,
                        genericName: status.userDisplayName,
                    }
                })
                .sort(function(a, b) {
                    let nameA = a.genericName.toLowerCase(),
                        nameB = b.genericName.toLowerCase()
                    if (nameA < nameB) return -1
                    if (nameA > nameB) return 1
                    return 0
                })

            this.statuses = statuses
            this.loading = false
        },

        setScope(scope) {
            this.selectedscope = scope
            this.getTickets()
        },

        setTicket(ticket) {
            this.selectedTicket = ticket
        },
    },

    computed: {
        availableScopes() {
            return this.ticketScopes
                .filter(el => el != this.selectedscope)
                .filter(el => {
                    let rank = this.$store.getters['auth/user'].role.rank
                    return rank <= el.rank
                })
        },

        computedTickets() {
            return this.tickets
                .filter(ticket => {
                    // Return true if no statusfilter is selected
                    if (this.selectedStatuses.length == 0) {
                        return true
                    }
                    // Check if status is in our list
                    return this.selectedStatuses.indexOf(ticket.status.id) > -1
                        ? true
                        : false
                })
                .filter(ticket => {
                    let str =
                        ticket.human_id +
                        ticket.subject +
                        ticket.description +
                        ticket.created.format()
                    return str
                        .toLowerCase()
                        .indexOf(this.ticketFilter.toLowerCase()) > -1
                        ? true
                        : false
                })
        },
    },
}
</script>
